import { render, staticRenderFns } from "./valList.vue?vue&type=template&id=170fe992&scoped=true&"
import script from "./valList.vue?vue&type=script&lang=js&"
export * from "./valList.vue?vue&type=script&lang=js&"
import style0 from "./valList.vue?vue&type=style&index=0&id=170fe992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170fe992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170fe992')) {
      api.createRecord('170fe992', component.options)
    } else {
      api.reload('170fe992', component.options)
    }
    module.hot.accept("./valList.vue?vue&type=template&id=170fe992&scoped=true&", function () {
      api.rerender('170fe992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/valManage/valList.vue"
export default component.exports